import "./subscription-appeal.m.css";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import get from "lodash/get";
import { AccessType } from "@quintype/components";
import { parseUrl } from "query-string";
import Loader from "../../../components/atoms/loader";
import IntegrationData from "../../../../../config/integrations.js";
import Axios from "axios";

export const HindiOfferAppeal = () => {
  const state = useSelector((state) => state);
  const [isHindi, setIsHindi] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const member = useSelector((state) => {
    return get(state, ["member"], null);
  });
  //const authUrl = "localhost:3000"
  const hasActiveSubscription = useSelector((state) =>
    get(state, ["fetchSubscription", "isActive"], null)
  );
  const { qt } = useSelector((state) => state);
  const authHost = qt.config.publisher.publisher.auth_host;
  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [error, setError] = useState(null);
  const [selectedPlanObj, setSelectedPlanObj] = useState({});
  const [hindiPlan, SetHindiPlan] = useState("3 months subscription");
  const [completedAmount, setCompletedAmount] = useState(9);
  const [targetAmount, setTargetAmount] = useState(800);
  const barWidth = (completedAmount / targetAmount) * 100;
  const fetchSubscription = useSelector((state) => state.fetchSubscription);

  useEffect(() => {
    setIsHindi(global.location.host.includes("hindi"));
    if (state.subscriptions && state.subscriptions.length) {
      
      let planObj = state.subscriptions.filter(
        (obj) => obj.name === "Hindi subscription plan"
      )[0];
      //console.log({ planObj });
      setSelectedPlanObj(planObj);
      // if( planObj && planObj.subscription_plans)  {
      //   planObj = planObj.subscription_plans.filter((obj) => obj.title === selectedPlan)[0]
      //   setSelectedPlanObj(planObj);}
    }
  }, [state]);

  useEffect(() => {
    Axios.get("https://server.newslaundry.com/hindiSubscribersCount/")
      .then((response) => {
        setCompletedAmount(response.data.userCount);
      })
      .catch((err) => {
        console.log(err);
        setCompletedAmount(9);
      });
  }, []);

  let successUrl = authHost; //global.location;
  const handleNotMember = async () => {
    const params = parseUrl(qt.currentPath);
    const callbackUrl = get(
      params,
      ["query", "callback-url"],
      global.location && global.location.origin
    );
    const redirectUrl = get(
      params,
      ["query", "redirect-url"],
      global && global.location && global.location.href
    );
    //console.log(`${authHost}/authenticate?redirect-url=${redirectUrl}&callback-url=${callbackUrl}&auth-page=${authHost}/user-login`, "url")
    window.location = `${authHost}/authenticate?redirect-url=${redirectUrl}&callback-url=${callbackUrl}&auth-page=${authHost}/user-login`;
  };
  const handlePayment = async (
    initAccessType,
    initRazorPayPayment,
    planName
  ) => {
    //console.log("insssss");
    //console.log("plan name", { planName });
    if (planName == "3 months subscription ") setLoading(true);
    else setLoading2(true);
    //pushToDataLayer("story_paywall_user_action", props.url, "subscribe");

    /* Redirect to login if not logged in */
    if (!member) {
      handleNotMember();
    }

    /* If not active subscriber then Proceed with subscription payment */
    if (true) {
      //console.log("insiiiideee");
      /* Initiate razorpay */
      if (selectedPlanObj && selectedPlanObj.subscription_plans) {
        const correctPlanObj = selectedPlanObj.subscription_plans.filter(
          (obj) => obj.title === planName
        )[0];
        const options = {
          argType: "options",
          selectedPlan: correctPlanObj,
          planType: "standard",
          couponCode: "",
          successUrl: successUrl,
          recipientSubscriber: {
            recipient_identity_provider: "email",
          },
        };
        // console.log({ options });
        //console.log(selectedPlanObj.subscription_plans);
        //   setSelectedPlanObj(planObj);}

        initRazorPayPayment(options)
          .then(async (res) => {
            // TODO need to store this invoice responce in store for my account
            await handlePaymentSuccess(res);
          })
          .catch((error) => {
            console.error(`Razorpay error: ${error}`);
            if (error.message === "user closed the payment") {
              setError("User closed the payment.");
            } else {
              setError("Oops! Something went wrong");
            }
            setLoading(false);
            setLoading2(false);
          });
      }
    }
  };

  const handlePaymentSuccess = async (res) => {
    setSuccessMsg(
      "Congratulations!! Payment Successful. Allow us couple of minutes to map your subscription."
    );
    setLoading(false);
    //window.location = successUrl;
  };

  const integrationsConfig = IntegrationData();
  const pub = useSelector((state) => get(state, ["qt", "config", "publisher"]));
  const email = get(member, ["email"], "");
  const phone = get(member, ["metadata", "phone"], "");
  const isStaging = get(pub, ["publisher", "accessTypeEnvironment"], true);
  const enableAccesstype = get(
    pub,
    ["publisher", "publisher", "enableAccesstype"],
    true
  );
  const accessTypeKey = isStaging
    ? integrationsConfig.stagingAccessTypeKey
    : integrationsConfig.accessTypeKey;
  const accessTypeBkIntegrationId = isStaging
    ? integrationsConfig.stagingAccessTypeBkIntegrationId
    : integrationsConfig.accessTypeBkIntegrationId;

  return (
    <>
    <div styleName="hindi-wrapper">
      <div styleName="hindi-paywall">
        <div styleName="content">
          <div styleName="left-container-2">
            <h1>स्वतंत्र पत्रकारिता यानि नागरिकों की आजादी की गारंटी</h1>
            <p>
              एक-दो बातें आपसे कहनी हैं. न्यूज़लॉन्ड्री की ये खबर आप तक
              पहुंचाने के पीछे हमारा मकसद एक सजग, जागरुक नागरिक तैयार करना
              है. इसका आधार स्वतंत्र और निष्पक्ष पत्रकारिता है,
              न्यूज़लॉन्ड्री हिंदी ने एक अलग रास्ता चुना है. सब्सक्रिप्शन का
              रास्ता. हमारी सात सदस्यों की टीम को आपके समर्थन की जरूरत है.
              {" "}
            </p>
            <p styleName="more-text">
            इस महीने हमारा लक्ष्य 800 नए सब्सक्राइबर बनाने का है, ताकि हम
              व्यावसायिक दबावों से मुक्त होकर जनहित की पत्रकारिता कर सकें.
              हिंदी टीम को आपका इंतजार है. क्या आप यह लक्ष्य पूरा करेंगे?{" "}
            </p>
            {/* <div styleName="hindi-benefits">
            <p>📹 हमारे पत्रकारों से सीधे मिलें</p>
            <p>🔓 प्रीमियम सामग्री खोलें</p>
            <p>✨ सब्सक्राइब के लिए विशेष आयोजन</p>
          </div> */}
          </div>
          <div styleName="right-container">
            <div styleName="bar-wrapper">
              <div styleName="amount-container">
                <div styleName="amount-wrapper">
                  <div styleName="amount" style={{ color: "white" }}>
                    {completedAmount}
                  </div>
                  <div styleName="goal">Subscribers so far</div>
                </div>
                <div styleName="amount-wrapper">
                  <div
                    styleName="amount select"
                    style={{
                      textAlign: "right",
                      width: "100%",
                      color: "white",
                    }}
                  >
                    {targetAmount}
                  </div>
                  <div styleName="goal">Target subscribers</div>
                </div>
              </div>
              <div styleName="progress-wrapper">
                <div
                  styleName="progress-bar"
                  style={{
                    width: barWidth + "%",
                    backgroundColor: "var(--nl-red)",
                  }}
                ></div>
              </div>
            </div>
            <div styleName="option-two">
              <div styleName="title-price-wrapper">
                <h1>3 महीने सब्सक्रिप्शन</h1>
                <div style={{ margin: "auto" }} styleName="price-wrapper">
                  <p
                    style={{
                      textDecoration: "line-through",
                      color: "gray",
                    }}
                  >
                    ₹900
                    {"   "}
                  </p>
                  <p>₹499</p>
                </div>
              </div>
              {/* <button styleName="ctav">सब्सक्राइब करें</button> */}
              <AccessType
                enableAccesstype={enableAccesstype}
                isAccessTypeCampaignEnabled={true}
                isStaging={false}
                accessTypeKey={accessTypeKey}
                accessTypeBkIntegrationId={accessTypeBkIntegrationId}
                email={email}
                phone={phone}
              >
                {({ initAccessType, initRazorPayPayment }) => {
                  return (
                    <>
                      {loading ? (
                        <button styleName="ctav">
                          <Loader color="white" />
                        </button>
                      ) : (
                        <button
                          onClick={() =>
                            handlePayment(
                              initAccessType,
                              initRazorPayPayment,
                              "3 months subscription "
                            )
                          }
                          styleName="ctav"
                        >
                          सब्सक्राइब करें
                        </button>
                      )}
                    </>
                  );
                }}
              </AccessType>
            </div>
            <div styleName="option-one">
              <div styleName="title-price-wrapper">
                <h1>6 महीने सब्सक्रिप्शन</h1>
                <div style={{ margin: "auto" }} styleName="price-wrapper">
                  <p
                    style={{
                      textDecoration: "line-through",
                      color: "gray",
                    }}
                  >
                    ₹1800{"   "}
                  </p>
                  <p>₹999</p>
                </div>
              </div>
              {/* <button styleName="ctav">सब्सक्राइब करें</button> */}
              <AccessType
                enableAccesstype={enableAccesstype}
                isAccessTypeCampaignEnabled={true}
                isStaging={false}
                accessTypeKey={accessTypeKey}
                accessTypeBkIntegrationId={accessTypeBkIntegrationId}
                email={email}
                phone={phone}
              >
                {({ initAccessType, initRazorPayPayment }) => {
                  return (
                    <>
                      {loading2 ? (
                        <button styleName="ctav">
                          <Loader color="white" />
                        </button>
                      ) : (
                        <button
                          onClick={() =>
                            handlePayment(
                              initAccessType,
                              initRazorPayPayment,
                              "6 months subscription "
                            )
                          }
                          styleName="ctav"
                        >
                          सब्सक्राइब करें
                        </button>
                      )}
                    </>
                  );
                }}
              </AccessType>
            </div>
          </div>
        </div>
      </div>
    </div>
    {error && <div styleName="error-message">{error}</div>}
  </>
  );
};
